import { render, staticRenderFns } from "./HomePartner.vue?vue&type=template&id=67982c66&scoped=true"
import script from "./HomePartner.vue?vue&type=script&lang=js"
export * from "./HomePartner.vue?vue&type=script&lang=js"
import style0 from "./HomePartner.vue?vue&type=style&index=0&id=67982c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67982c66",
  null
  
)

export default component.exports